import { useMutation } from 'react-query';
import type { UseMutationResult } from 'react-query';
import type { DownloadSurveyResponsesResult } from '../DownloadSurveyResponsesResult';
import type { DownloadSurveyResponsesVariables } from './downloadSurveyResponses';
import { downloadSurveyResponses } from './downloadSurveyResponses';

export function useDownloadSurveyResponsesMutation(): UseMutationResult<
  DownloadSurveyResponsesResult,
  unknown,
  DownloadSurveyResponsesVariables,
  unknown
> {
  return useMutation((params) => downloadSurveyResponses(params));
}
